import { BlossomCustomerNotification, ExpLineOfBusiness, FunnelLocation } from "__generated__/api";
import Actions = BlossomCustomerNotification.Actions;
import { PageStore } from "bernie-core";

export const lineOfBusinessMapper: Record<string, ExpLineOfBusiness> = {
  H: ExpLineOfBusiness.HOTEL,
  P: ExpLineOfBusiness.PACKAGES,
  F: ExpLineOfBusiness.FLIGHT,
  C: ExpLineOfBusiness.CAR,
  CR: ExpLineOfBusiness.CRUISES,
  A: ExpLineOfBusiness.ACTIVITIES,
  U: ExpLineOfBusiness.UNCLASSIFIED,
  R: ExpLineOfBusiness.RAILS,
  GT: ExpLineOfBusiness.GROUNDTRANSFERS,
};

export const getLineOfBusiness = (lineOfBusiness: string): ExpLineOfBusiness =>
  lineOfBusinessMapper[lineOfBusiness] || ExpLineOfBusiness.UNCLASSIFIED;

export const funnelLocationMapper: Record<string, FunnelLocation> = {
  0: FunnelLocation.SYSTEM,
  10: FunnelLocation.ENTRY,
  20: FunnelLocation.SEARCH_RESULTS,
  30: FunnelLocation.DETAILS,
  40: FunnelLocation.CHECKOUT,
  50: FunnelLocation.CHECKOUT_ERROR,
  60: FunnelLocation.PAYMENT_ERROR,
  70: FunnelLocation.CONFIRMATION,
  80: FunnelLocation.POST_BOOKING,
  90: FunnelLocation.USER,
  500: FunnelLocation.FEATURES,
};

export interface IdentityWithDialog {
  pageId: string;
  lineOfBusiness: string;
  funnelLocation: string;
}

export const getIdentity = (page: PageStore): IdentityWithDialog => {
  const [pageId, lineOfBusiness, funnelLocation] = page.pageId.split(",").map((identifier) => identifier.trim());

  return { pageId, lineOfBusiness, funnelLocation };
};

export const getFunnelLocation = (funnelLocation: string): FunnelLocation =>
  funnelLocationMapper[funnelLocation] || FunnelLocation.ENTRY;

/* istanbul ignore next */
export const sendAnalytics = (
  actions: Actions[],
  analyticsCallback: (rfrr: string, linkName: string | null) => void
) => {
  if (actions && analyticsCallback) {
    actions.forEach((action: Actions) => {
      if (action.__typename === "CustomerNotificationAnalytics") {
        const description = action.description as string;
        analyticsCallback(action.referrerId, description);
      }
    });
  }
};
